export const API_URL = 'https://api.themoviedb.org/3';



export const BASE_URL = 'http://localhost:3000';

export const twitterData = {
  'twitter:card': 'summary_large_image',
  'twitter:site': '@i_mridul',
  'twitter:creator': '@i_mridul',
};

export const ogDefault = {
  'og:site_name': 'Lights-Out',
  'og:type': 'website',
  'og:locale': 'en_US',
};

export const ogImage =
  'https://res.cloudinary.com/dbxcernxw/image/upload/v1653805696/CineParadis/cineparadis-of_lbiam4.jpg';
